import { CircularProgress, IconButton, TextField, Tooltip } from '@mui/material';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import CustomModal from '../customModal/CustomModal';
import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { sendNotification } from 'src/utils/sendNotification';
import { Box } from '@mui/system';

function RejectApplication({ item, refetchListData }) {
  const dispatch = useDispatch();
  const messageBodyRef = useRef<string>('');
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const socket = useSelector((store: RootState) => store.socket.socket);
  const [loading, setLoading] = useState<boolean>(false);
  const currentPermitDetails = useSelector(
    (store: RootState) => store.currentPermit.currentPermitDetails
  );

  const rejectApplication = async () => {
    setLoading(true);
    type Payload = {
      ApplicationID: string;
      ApplicationStatus: string;
      ReasonOfRejection?: string;
    };
    const payload: Payload = {
      ApplicationID: item?.ApplicationID,
      ApplicationStatus: 'Rejected',
      ReasonOfRejection: messageBodyRef.current
    };

    const response = await httpRequest(
      'PUT',
      `/applications/${currentPermitDetails?.id}/update_status`,
      payload
    );

    if (response.status === 'success') {
      sendNotification(socket, {
        UserID: item?.UserID, // receiver user ID --
        TownshipID: currentPermitDetails?.townshipId,
        ApplicationID: item?.ApplicationID,
        PermitID: currentPermitDetails?.id,
        Title: 'Application Rejected',
        Message: `Application no. (${item?.ApplicationNumber}) is rejected. ${messageBodyRef.current}`,
        ApplicationNumber: item?.ApplicationNumber
      });
      setIsOpen(false);
      setLoading(false);
      messageBodyRef.current = '';
      refetchListData();
      toast.success(response.message);
    } else {
      setLoading(false);
      setIsOpen(false);
      messageBodyRef.current = '';
      dispatch(handleError(response?.message));
    }
  };

  return (
    <div>
      <Tooltip title="Reject" arrow>
        <IconButton
          disabled={
            item.ApplicationStatus === 'Rejected' ||
            item.ApplicationStatus === 'Withdrawn' ||
            item.ApplicationStatus === 'Approved' ||
            item.ApplicationStatus === 'Approved Closed' ||
            item.ApplicationStatus === 'Closed Out'
          }
          color="error"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <ContentPasteOffIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {loading ?
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent overlay
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300, // Ensure overlay is above other components
            textAlign: 'center',
            padding: 2
          }}
        >
          <CircularProgress size={60} />
        </Box> : <CustomModal
          title={'Reject Application?'}
          IsOpen={IsOpen}
          setIsOpen={setIsOpen}
          messageBodyRef={messageBodyRef}
          loading={loading}
          onSave={() => {
            if (
              !messageBodyRef.current ||
              (messageBodyRef.current[0] === ' ' &&
                messageBodyRef.current.length === 1)
            )
              toast.error("Reason field can't be empty.");
            else rejectApplication();
          }}
          actionButtons={['Close', 'Confirm']}
          content={
            <>
              <TextField
                required
                className="txtArea"
                label="Reason"
                placeholder="Reason"
                name="Reason"
                multiline
                onChange={(e) => {
                  messageBodyRef.current = (e.target.value).trim();
                }}
                sx={{ width: '600px' }}
                rows={3}
              />
            </>
          }
        />
      }

    </div>
  );
}

export default RejectApplication;
